@if (getTicketDetails$ | async; as getTicketDetails) {
  <ion-content>
    @if (
      getTicketDetails[0] && getTicketDetails[0]?.get_prize_breakdown_ticket_based_on_date?.response?.status !== 'fail') {
      <div
        class="page-background-blue"
        >
        @if (
          getTicketDetails[0] && getTicketDetails[0]?.get_prize_breakdown_ticket_based_on_date?.response?.ticket_details
          ; as ticketDetails) {
          <ion-fab vertical="top" horizontal="start" slot="fixed">
            <ion-icon name="arrow-back" class="close-fab" (click)="goBack()"></ion-icon>
          </ion-fab>
          <h1 class="header-text heading-tickets">{{ "checked-tickets.tickets" | translate }}</h1>
          <h1 class="txt-clr-light-blue syndicate-name">
            {{
            ticketDetails && ticketDetails[0] && ticketDetails[0].syndicate_name ? ticketDetails[0]?.syndicate_name : ""
            }}
          </h1>
          @if (showSlides) {
            <ion-slides [options]="ticketSlider">
              @for (ticketDetail of ticketDetails; track ticketDetail) {
                <ion-slide>
                  <ion-card class="ticket-card-size">
                    <ion-grid>
                      <ion-row class="jackpot-details-row">
                        <!--Jackpot Details-->
                        <ion-col size="2">
                          <img class="jackpot-logo" src="{{ ticketDetail?.product_image_url }}" alt="product-image" />
                        </ion-col>
                        <ion-col size="6">
                          <h3 class="jackpot-name ion-text-left">EuroMillions</h3>
                          <p class="lines-available ion-text-left">
                            {{ ticketDetail?.draw_day }} {{ ticketDetail?.draw_date }}
                          </p>
                        </ion-col>
                        <ion-col size="4" class="ion-no-padding">
                          <h1 class="syndicate-name txt-clr-light-blue ion-text-right txt-players">
                            {{ "checked-tickets.Players" | translate }}
                          </h1>
                          <p class="players-count txt-clr-light-blue">{{ ticketDetail?.syndicate_size }}</p>
                        </ion-col>
                      </ion-row>
                      @for (ticket of ticketDetail?.ticket; track ticket; let i = $index) {
                        <ion-row class="ticket-number-row">
                          <!--Ticket Numbers-->
                          <ion-col class="ion-no-padding">
                            <h1 class="ticket-serial">{{ alphabeticOrder(i) }}</h1>
                          </ion-col>
                          @for (number of ticket?.ticket_numbers; track number) {
                            <ion-col class="ion-no-padding">
                              @if (number.match === 'yes') {
                                <div class="winnings-badge"></div>
                              }
                              <h1 class="ticket-number">{{ number.no }}</h1>
                            </ion-col>
                          }
                          @for (number of ticket?.bonus_numbers; track number) {
                            <ion-col class="ion-no-padding">
                              @if (number.match === 'yes') {
                                <div class="winnings-badge"></div>
                              }
                              <h1 class="ticket-number golden-ticket-number">{{ number.no }}</h1>
                            </ion-col>
                          }
                          <ion-col class="ion-no-padding" size="2">
                            <h1 class="ticket-number amount-won-line">£{{ ticket.win_value }}</h1>
                          </ion-col>
                        </ion-row>
                      }
                      <ion-row>
                        <h3 class="txt-winning-combination">{{ "checked-tickets.combination" | translate }}</h3>
                      </ion-row>
                      <ion-row class="margin-min">
                        @for (winningNumber of ticketDetail?.result_numbers; track winningNumber) {
                          <ion-col size="1.3">
                            <h1 class="ticket-number">{{ winningNumber?.no }}</h1>
                          </ion-col>
                        }
                        @for (winningNumber of ticketDetail?.result_bonus_numbers; track winningNumber) {
                          <ion-col size="1.3">
                            <h1 class="ticket-number golden-ticket-number">{{ winningNumber?.no }}</h1>
                          </ion-col>
                        }
                        <ion-col class="jackpot-total-amount" size="2.9">
                          <h1 class="ticket-number amount-won-line">£{{ ticketDetail?.jackpot_value }}</h1>
                        </ion-col>
                      </ion-row>
                      <ion-row class="view-mill-section">
                        <ion-button color="secondary" expand="block" class="capsule-btn" type="submit">
                          {{ "checked-tickets.Makers" | translate }}
                        </ion-button>
                      </ion-row>
                    </ion-grid>
                  </ion-card>
                </ion-slide>
              }
            </ion-slides>
          }
        }
      </div>
    } @else {
      <app-in-progress-animation></app-in-progress-animation>
    }
  </ion-content>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}
